/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureResourceSummaryBatchResponse {
    getFixupPrototypeFunction() { return TagPostureResourceSummaryBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<TagPostureResourceSummaryBatchResponse>): TagPostureResourceSummaryBatchResponse {
        let obj = Object.assign(new TagPostureResourceSummaryBatchResponse(), model);
        TagPostureResourceSummaryBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureResourceSummaryBatchResponse>): TagPostureResourceSummaryBatchResponse {
        if (!model) return null;
        return TagPostureResourceSummaryBatchResponse.newInstance(<TagPostureResourceSummaryBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureResourceSummaryBatchResponse) {
        if (!obj) return;

        models.TagPostureResourceSummaryBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureResourceSummaryBatchResponse): boolean {
        Object.setPrototypeOf(obj, TagPostureResourceSummaryBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.TagPostureResourceSummary.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.TagPostureResourceSummary; };

}
